// stores/useCodeStore.ts
import { defineStore } from 'pinia';

interface CodeItem {
  codeGrpId: string;
  codeGrpNm: string;
  codeId: string;
  codeNm: string;
}

export const useCodeStore = defineStore('code', {
  state: () => ({
    codeList: [] as CodeItem[],
  }),

  getters: {
    // 특정 그룹 + 코드ID로 코드명 가져오기
    getCodeNm: state => {
      return (codeGrpId: string, codeId: string) => {
        const item = state.codeList.find(c => c.codeGrpId === codeGrpId && c.codeId === codeId);
        return item ? item.codeNm : '';
      };
    },
  },

  actions: {
    // 로그인 성공 후 초기화
    async initCodeList(codeList: any) {
      console.log('코드 목록 초기화:', codeList?.length || 0);
      try {
        this.codeList = codeList;
      } catch (e) {
        console.error('코드 목록 초기화 실패:', e);
        this.codeList = [];
      }
    },
    // 특정 그룹의 코드 목록 가져오기 (없으면 API 호출하여 캐싱)
    async getCodeList(codeGrpId: string) {
      // 이미 해당 그룹의 데이터가 있는지 확인
      const existingCodes = this.codeList.filter(c => c.codeGrpId === codeGrpId);

      if (existingCodes.length > 0) {
        // 캐시된 데이터가 있으면 반환
        return existingCodes.map(c => ({ codeId: c.codeId, codeNm: c.codeNm }));
      }

      // 캐시된 데이터가 없으면 API 호출
      try {
        const response = await this.fetchCodeList(codeGrpId);

        if (response?.list) {
          // 새로운 코드 목록을 기존 codeList에 추가 (append)
          const newCodes = response.list.map((item: any) => ({
            codeGrpId: codeGrpId,
            codeGrpNm: item.codeGrpNm || '',
            codeId: item.codeId,
            codeNm: item.codeNm,
          }));

          this.codeList = [...this.codeList, ...newCodes];

          return newCodes.map(c => ({ codeId: c.codeId, codeNm: c.codeNm }));
        }

        return [];
      } catch (e) {
        console.error(`코드 그룹 ${codeGrpId} 조회 실패:`, e);
        return [];
      }
    },
    // 공통 코드 목록 조회 (내부 메소드)
    async fetchCodeList(codeGrpId: string) {
      try {
        const { fetchCommonCdList } = useCommonApi();
        const params = new URLSearchParams();
        params.append('codeGrpId', codeGrpId);
        const response = await fetchCommonCdList(params);
        return response;
      } catch (e) {
        console.error('공통 코드 목록 조회 실패:', e);
        throw e;
      }
    },
    // 인사 코드 목록 조회(직위,직급,직무)
    async fetchInsaCodeList(year: string, evalCycleCd: string) {
      try {
        const { fetchInsaCodeList } = useCommonApi();
        const params = new URLSearchParams();
        params.append('year', year);
        params.append('evalCycleCd', evalCycleCd);
        const response = await fetchInsaCodeList(params);
        return response;
      } catch (e) {
        console.error('공통 코드 목록 조회 실패:', e);
        throw e;
      }
    },
  },
});
